import { styled } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, AppBar, Typography, Button, LinearProgress, DialogActions, FormControl } from '@mui/material';
import DropArea from 'global/components/drop-area';

export const PhotosDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '80vw',
    height: '80vh',
    // PFM-2613: ensure the paper is a flex column so the DialogContent can flex
    // to fill the space between the title AppBar and the DialogActions.
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(1),
      width: '100vw',
      height: '100vh',
    },
  },
}));

export const PhotosDialogTitle = styled(DialogTitle)({
  padding: 0,
});

// PFM-2613: make the dialog body a flex column that fills the space between the
// title AppBar and the DialogActions, so the drop zone can stretch to fill it.
export const PhotosDialogContent = styled(DialogContent)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  // Prevent the dialog body from growing an outer scrollbar; the drop zone
  // scrolls its previews internally instead.
  minHeight: 0,
  overflow: 'hidden',
});

export const PhotosAppBar = styled(AppBar)({});

export const AppBarTitle = styled(Typography)({
  textAlign: 'center',
  width: '100%',
  marginRight: 40,
});

export const PhotosLoader = styled(LinearProgress)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(8.5),
  width: '100%',
}));

export const PhotosDialogActions = styled(DialogActions)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const PhotosDialogButton = styled(Button)({});

export const LocationSelect = styled(FormControl)(({ theme }) => ({
  width: '30%',
  marginLeft: 'auto',
  marginRight: theme.spacing(2),
}));

// PFM-2613: fill the dialog body so the entire modal body is a drop/click
// target. `flex: 1` + `minHeight: 0` lets the dashed box grow to the available
// height, while the shared DropArea Container's existing `overflow: auto` keeps
// the previews scrolling inside the box rather than producing an outer
// modal scrollbar.
export const PhotosDropZone = styled(DropArea)(({ theme }) => ({
  marginTop: theme.spacing(1),
  flex: 1,
  minHeight: 0,
}));

// Image card styles ---------------------------------------------------------

export const ImageRoot = styled('div')({
  width: '22%',
  margin: '1.5%',
  position: 'relative',

  '& button': {
    minWidth: 'auto',
  },
});

export const DeleteBtn = styled(Button)({
  position: 'absolute',
  top: 5,
  right: 5,
});

export const RankContainer = styled('div')({
  position: 'absolute',
  bottom: 0,
  height: 40,
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
});

export const PosRank = styled(Button)(({ theme }) => ({
  color: theme.palette.success.main,
  marginRight: theme.spacing(1),
}));

export const NegRank = styled(Button)(({ theme }) => ({
  color: theme.palette.error.main,
  marginLeft: theme.spacing(1),
}));
